// extracted by mini-css-extract-plugin
export default {"headerSection":"HeaderSection_headerSection__XZnxx","titleSection":"HeaderSection_titleSection__rT8EE","progressSection":"HeaderSection_progressSection__zhfhj"};